//Mozilla/5.0 (Linux; Android 7.0; SM-G930F Build/NRD90M; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/64.0.3282.137 Mobile Safari/537.36

import React from 'react';
import { Box, Typography } from '@mui/material';

// Versione minimale per test - solo Hello World
const TvDisplayPageLegacy = () => {
    // Log per debug
    
    /* Stati e logica carosello commentati
    const [images, setImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    
    // Carica le immagini - migliorata gestione fallback
    useEffect(function loadImages() {
        async function fetchImages() {
            try {
                // Prova prima a caricare da API
                const response = await axios.get('/carousel/active');
                if (response.data && response.data.length > 0) {
                    const processedImages = response.data.map(function(image) {
                        return {
                            ...image,
                            url: image.url.startsWith('http') 
                                ? image.url 
                                : `${process.env.PUBLIC_URL}/${image.url || 'images/carousel/' + image.filename}`
                        };
                    });
                    setImages(processedImages);
                } else {
                    // Fallback statico simile al vecchio progetto
                    const fallbackImages = [];
                    for (let i = 1; i <= 16; i++) {
                        fallbackImages.push({
                            id: i,
                            title: `Immagine ${i}`,
                            duration: 8,
                            url: `${process.env.PUBLIC_URL}/slide/${i}.jpg`
                        });
                    }
                    setImages(fallbackImages);
                }
            } catch (error) {
                console.error("Errore caricamento immagini:", error);
                // Fallback minimale con un'immagine
                setImages([
                    { id: 1, url: `${process.env.PUBLIC_URL}/slide/1.jpg`, title: 'Casa Francescana', duration: 8 }
                ]);
            }
        }
        fetchImages();
    }, []);
    
    // Carosello migliorato - mantenuto e semplificato
    useEffect(function setupCarousel() {
        if (!images.length) return;
        
        const currentImage = images[currentImageIndex];
        // Usa la durata specificata nell'immagine o default 8 secondi
        const duration = (currentImage && currentImage.duration) ? currentImage.duration * 1000 : 8000;
        
        const timerId = setTimeout(() => {
            setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
        }, duration);
        
        return () => clearTimeout(timerId);
    }, [images, currentImageIndex]);
    */
    
    return (
        <Box sx={{ 
            width: '100vw', 
            height: '100vh', 
            overflow: 'hidden',
            backgroundColor: 'black',
            color: 'white',
            fontFamily: 'Arial, sans-serif',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            {/* Etichetta versione Legacy */}
            <Box sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                zIndex: 1000,
                backgroundColor: 'rgba(255, 165, 0, 0.8)',
                color: 'text.primary',
                padding: '5px 15px',
                borderBottomLeftRadius: '10px',
                fontWeight: 'bold',
                fontSize: '1.5vw',
                boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
                VERSIONE LEGACY
            </Box>
            
            {/* Simple Hello World test */}
            <Typography sx={{
                fontSize: '5vw',
                fontWeight: 'bold',
                textAlign: 'center',
                color: 'white',
                textShadow: '0 0 10px rgba(255, 255, 255, 0.5)'
            }}>
                Hello World
            </Typography>
            
            {/* Carosello commentato
            {images.length > 0 && (
                <Box sx={{ 
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden'
                }}>
                    <img
                        src={images[currentImageIndex].url}
                        alt={images[currentImageIndex].title || ''}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                    
                    {images[currentImageIndex].title && (
                        <Box sx={{ 
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            backgroundColor: 'rgba(0,0,0,0.7)',
                            padding: '2vh',
                        }}>
                            <Typography sx={{
                                color: 'white',
                                fontSize: '3vw',
                                textAlign: 'center',
                                fontWeight: '500'
                            }}>
                                {images[currentImageIndex].title}
                            </Typography>
                        </Box>
                    )}
                </Box>
            )} */}
        </Box>
    );
};

export default TvDisplayPageLegacy;